import React from "react";
import TopNavBar from "../TopNavBar/TopNavBar";
import { useNavigate } from "react-router-dom";

function UnifiedHealthInsurancePlan() {
  const navigate = useNavigate();
  return (
    <div>
      <TopNavBar />
      <div className="d-flex flex-column justify-content-center align-items-center p-5  bg-light ">
        <div
          // className="card shadow rounded-4 p-4 mb-3 text-center"
          className=" rounded-4 p-4 mb-3 text-center"
          style={{ maxWidth: "500px", width: "100%" }}
        >
          <h5 className="mt-3 mb-1  payment-success-label">Coming Soon...</h5>
        </div>
        <div>
          <button
            onClick={() => navigate("/")}
            className="plan-textb btn btn-light flex-fill rounded-4 py-2 px-5 fw-bold"
          >
            Back to home
          </button>
        </div>
      </div>
    </div>
  );
}

export default UnifiedHealthInsurancePlan;
